import React from 'react';

import {
    Category,
    GuestImage,
    Image,
    UnitImage,
    Video,
} from 'proto/Hotel/HotelMedia';

export enum GalleryType {
    Images = 'imageList',
    GuestImages = 'guestImageList',
    Panoramas = 'panoramaList',
    UnitImages = 'unitImageList',
    Videos = 'videoList',
}

export interface OpenGalleryProps {
    hotelId: number;
    withUnits?: boolean; // get units ?
    category?: CategoryType; // default category selection
    closeAfterCallback?: boolean; // close modal after callback ?
    callback?: (e?: React.MouseEvent) => void; // show cta in header ?
    step4Url?: string; // show cta in header ?
    shareLeafletUrl?: string; // show share/leaflet in header ?
}

export interface StageProps {
    hotelId: number;
    step4Url?: string;
    shareLeafletUrl?: string;
    onHeaderCtaClick?: () => void;
    closeGallery: () => void;
}

export interface GuestRatingImage {
    ratingId: number;
    index: number;
}

export type CurrentListType = Image[] | GuestImage[] | Video[] | UnitImage[];
export type CategoryType = Category | number; // predefined categories or unitId
export type CategoryListType = CategoryType[];

export const translationFilterMap: Record<Category, string> = {
    [Category.All]: 'TRANS-all-images',
    [Category.Pool]: 'TRANS-pool',
    [Category.OutsideView]: 'TRANS-outer-view',
    [Category.InsideView]: 'TRANS-interior',
    [Category.Room]: 'TRANS-room',
    [Category.FreeTime]: 'TRANS-free-time',
    [Category.Location]: 'TRANS-surroundings',
};
